// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressIndicator_progressBar__mgipt","shimmer":"ProgressIndicator_shimmer__YvSYI","stepCount":"ProgressIndicator_stepCount__jZmOu"};